// extracted by mini-css-extract-plugin
export var bodySections = "_5y-8";
export var gray = "_5y-7";
export var green = "_5y-4";
export var iconContainer = "_5y-9";
export var iconWidgetContainer = "_5y-1";
export var phoneIcon = "_5y-2";
export var red = "_5y-5";
export var statusDot = "_5y-3";
export var widgetContainer = "_5y-0";
export var yellow = "_5y-6";